import { widget } from "@foretagsplatsen/widgetjs";
import keyFigureValueWidget from "./keyFigureValueWidget.js";

/**
 * Displays a summary of some of the most essential KeyFigures.
 *
 * @param {boolean} [spec.canViewAccountingDocuments] - If false, links to KPI documents are not displayed.
 * @param {{}} spec - widget spec - Parameter object
 * @param {{}} my - protected fields holder
 * @param {boolean} [spec.canViewKeyFigure] - If false, call to action to view the KPI is disabled
 * @param {renderable} [spec.navigateToViewKeyFigureDisableMessage] - Message to show when the KPI call to action is disabled
 */
function keyFigureOverviewWidget(spec, my) {
	my ||= {};
	spec ||= {};

	const that = widget(spec, my);

	my.navigateToViewKeyFigureDisableMessage =
		spec.navigateToViewKeyFigureDisableMessage;

	my.canViewKeyFigure = spec.canViewKeyFigure;

	my.canViewAccountingDocuments = spec.canViewAccountingDocuments !== false;

	/**
	 * Sets the KeyFigure values to display
	 *
	 * @param {keyFigureValue[]} keyFigureValues - Values for the keyFigure
	 */
	that.show = function (keyFigureValues) {
		my.keyFigureValues = keyFigureValues.map((keyFigureValue) =>
			keyFigureValueWidget({
				canViewAccountingDocuments: my.canViewAccountingDocuments,
				keyFigureValue,
				canViewKeyFigure: my.canViewKeyFigure,
				navigateToViewKeyFigureDisableMessage:
					my.navigateToViewKeyFigureDisableMessage,
			}),
		);

		that.update();
	};

	that.setCanViewKeyFigure = function (value) {
		my.canViewKeyFigure = value;
	};

	that.isEmpty = function () {
		return my.keyFigureValues.length === 0;
	};

	my.keyFigureValues = [];

	that.renderContentOn = function (html) {
		html.div(
			{
				id: "keyfigures-container",
				class: "clearfix",
			},
			my.keyFigureValues,
		);
	};

	return that;
}

export default keyFigureOverviewWidget;
